import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InvestmentAmount from '../InvestmentAmount'
import { knowsHowMuchToInvestOptionSelected, monthlyInvestmentAmountSelected, onceOffInvestmentAmountSelected } from '../searchCriteriaActions'
import { fetchKnowsHowMuchToInvestOptions } from './investmentAmountContainerActions'
import { connect } from 'react-redux'
import Spinner from '../../../common/Spinners/Spinner'

class InvestmentAmountContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    knowsHowMuchToInvestOptions: PropTypes.array.isRequired,
    knowsHowMuchToInvestOptionSelected: PropTypes.func.isRequired,
    selectedKnowsHowMuchToInvestOptionId: PropTypes.number,
    knowsHowMuchToInvestOptionsLoading: PropTypes.bool.isRequired,
    investmentAmounts: PropTypes.object.isRequired,
    monthlyInvestmentAmountSelected: PropTypes.func.isRequired,
    onceOffInvestmentAmountSelected: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
  }

  constructor (props) {
    super(props)
    this.knowsHowMuchToInvestOptionSelected = this.knowsHowMuchToInvestOptionSelected.bind(this)
    this.monthlyInvestmentAmountSelected = this.monthlyInvestmentAmountSelected.bind(this)
    this.onceOffInvestmentAmountSelected = this.onceOffInvestmentAmountSelected.bind(this)
  }

  componentDidMount () {
    this.props.dispatch(fetchKnowsHowMuchToInvestOptions())
  }

  knowsHowMuchToInvestOptionSelected (knowsHowMuchToinvestOptionId) {
    this.props.dispatch(this.props.knowsHowMuchToInvestOptionSelected(knowsHowMuchToinvestOptionId))
  }

  monthlyInvestmentAmountSelected (monthlyInvestmentAmount) {
    this.props.dispatch(this.props.monthlyInvestmentAmountSelected(monthlyInvestmentAmount))
  }

  onceOffInvestmentAmountSelected (onceOffInvestmentAmount) {
    this.props.dispatch(this.props.onceOffInvestmentAmountSelected(onceOffInvestmentAmount))
  }

  render () {
    if (this.props.knowsHowMuchToInvestOptionsLoading) {
      return <Spinner />
    }
    return <InvestmentAmount
      showValidationErrors={this.props.showValidationErrors}
      validation={this.props.validation}

      knowsHowMuchToInvestOptions={this.props.knowsHowMuchToInvestOptions}
      knowsHowMuchToInvestSelected={this.knowsHowMuchToInvestOptionSelected}
      selectedKnowsHowMuchToInvestOptionId={this.props.selectedKnowsHowMuchToInvestOptionId}

      investmentAmounts={this.props.investmentAmounts}
      monthlyInvestmentAmountSelected={this.monthlyInvestmentAmountSelected}
      onceOffInvestmentAmountSelected={this.onceOffInvestmentAmountSelected}
    />
  }
}

const mapStateToProps = (state) => {
  return {
    selectedKnowsHowMuchToInvestOptionId: state.findAnIfa.searchCriteria.selectedKnowsHowMuchToInvestOptionId,
    investmentAmounts: state.findAnIfa.searchCriteria.investmentAmounts,
    knowsHowMuchToInvestOptions: state.investmentAmountContainer.knowsHowMuchToInvestOptions,
    knowsHowMuchToInvestOptionsLoading: state.investmentAmountContainer.knowsHowMuchToInvestOptionsLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    knowsHowMuchToInvestOptionSelected: knowsHowMuchToInvestOptionSelected,
    monthlyInvestmentAmountSelected: monthlyInvestmentAmountSelected,
    onceOffInvestmentAmountSelected: onceOffInvestmentAmountSelected,
    dispatch: dispatch,
    fetchKnowsHowMuchToInvestOptions: fetchKnowsHowMuchToInvestOptions
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentAmountContainer)
